
import { defineComponent, ref } from "vue";
import {
  Container,
  Section,
  Heading2,
  Paragraph,
  NarrowContainer,
} from "@/components/layout";
import { Photo, ContactList } from "./components";
import { useContent, useOnScrollTransition } from "@/hooks";

export default defineComponent({
  name: "About",
  components: {
    Container,
    Section,
    Heading2,
    Paragraph,
    Photo,
    NarrowContainer,
    ContactList,
  },
  setup() {
    const { contacts } = useContent();
    const description = ref([]);

    useOnScrollTransition(description, "animate-scroll-top");

    return { entities: contacts, description };
  },
});
